import { getTableLayout, handleTableAccounts } from "../../../Tools/Requests";
import { getRightsData } from "../../../Tools/Tools";
import { parseColumns, ParsedColumn } from "../../GridTools/parseColumnTools";
import { createGrid, createRecordSource, mfDelete, mfEdit } from "../../rcsgrid";
import { isAdminAtom, smetaStore } from "../../../../../atoms";

export async function accountsGrid(grid: createGrid, source: createRecordSource, props, data) {
  const json = await getTableLayout<{ JSONType: string; Rights: string; Columns: unknown }>({
    module: props.Module,
    objType: data.ObjType,
    sectionId: props.SectionID,
  });
  source.onHandleRequest = handleTableAccounts(props.Module, data.ObjType, data.GroupID, props.SectionID);
  if (data.setSelectedRecord)
    source.onRecordIndexChanged = (source) => {
      data.setSelectedRecord(source.getFieldTextSync("ID"));
    };
  grid.setImageFields(["CloseDate", "ExternalKey"]);
  grid.canModify = (flag: number, column: ParsedColumn | undefined, grid: createGrid) => {
    if (props.disabled) return false;
    if (!grid.localCanModify(flag, column, grid)) return false;
    // if (TableCodeOption(TableCode_Locked)) return false;
    if (column?.fieldName === "ExternalKey" && !smetaStore.get(isAdminAtom)) return false;
    if ([mfDelete, mfEdit].includes(flag)) return !Boolean(source.getFieldTextSync("ExternalKey"));
    return true;
  };
  await source.open();
  if (json) {
    source.rights = getRightsData(json.Rights);
    grid.setColumns(parseColumns(json));
  } else grid.defaultColumns = true;
  await source.refresh();
  await grid.setSource(source);
  data.setSelectedRecord?.(await source.getFieldText("ID"));
  await grid.updateGridSize();
}
